/* eslint-disable react/prop-types, react/no-multi-comp */

import React from "react"
import ReactDOM from "react-dom"
import classnames from "classnames"
import { connect } from "react-redux"

import BodyLayer from "../../../../app/scripts/components/BodyLayer"
import * as scrollUtils from "common/utils/scrollUtils"
import CloseByKey from "../CloseByKey/CloseByKey"
import { isMobileSelector } from "../../services/window"
import { setPopupState, unsetPopupState } from "../../services/popupState/PopupStateDuck"

class Popup extends React.Component {
  static defaultProps = {
    show: true, // default is true because originally this element should be hidden by removing from DOM
    customHeightLimit: 760,
  }

  componentDidMount() {
    const { scrollBlock, onContentDidMount, className } = this.props

    this.props.setPopupState({ openedPopup: className })
    if (scrollBlock) {
      scrollUtils.handleBlockScrollBody(true)
    }
    if (onContentDidMount) {
      onContentDidMount(this.contentRef)
    }
  }

  componentWillUnmount() {
    const { scrollBlock } = this.props

    this.props.unsetPopupState(this.props.className)
    if (scrollBlock) {
      scrollUtils.handleBlockScrollBody(false)
    }
  }

  setHeight = () => {
    // if window height is lower than 500px then last three languages aren't visible on  language picker
    const { customHeight, customHeightLimit, cookiesBannerHeight } = this.props
    if (customHeight) {
      if (window) {
        if (window.innerHeight < customHeightLimit) {
          return window.innerHeight - 50 - cookiesBannerHeight
        }
      }
    }
    return "auto"
  }

  handleHide = target => {
    const { keepOnPopup, onHide } = this.props

    if (
      !(
        (this.inner && ReactDOM.findDOMNode(this.inner).contains(target)) ||
        target.nodeName === "HTML" ||
        (keepOnPopup && target.closest(".Popup"))
      ) &&
      onHide
    ) {
      onHide(target)
    }
  }

  contentRef = React.createRef()

  render() {
    const className = classnames(
      "Popup",
      this.props.show ? "_shown" : "_hidden",
      this.props.custom ? "_custom" : "_default",
      this.props.className,
    )

    return (
      <CloseByKey onClose={this.props.onHide}>
        <div
          className={className}
          style={{ ...this.props.style, height: this.setHeight() }}
          ref={this.contentRef}
          data-test="Popup"
        >
          {this.props.arrow && <div className="arrow" style={{ left: this.props.arrowPosition }} />}
          {this.props.show ? <BodyLayer onHide={this.handleHide} /> : ""}
          <div
            className="Popup-content"
            ref={ref => {
              this.inner = ref
            }}
          >
            {this.props.children}
          </div>
        </div>
      </CloseByKey>
    )
  }
}

// $FlowFixMe TODO: plz add type when updating
export default connect(
  state => ({
    isBookingPage: state.page.get("name") === "booking",
    isMobile: isMobileSelector(state),
    cookiesBannerHeight: state.cookiesBanner,
  }),
  { setPopupState, unsetPopupState },
)(Popup)
